/**
 * 车队选项数据管理 Hook
 */
import { useState, useEffect } from 'react';
import { cateAllCompanyRequest } from '@/service/fleetRisk';
import { companyListRequest } from '@/service/companyManage';

export const useFleetOptions = () => {
  const [fleetOptions, setFleetOptions] = useState<any[]>([]);

  useEffect(() => {
    fetchFleetList();
  }, []);

  const fetchFleetList = async (name='') => {
    try {
      const res = await companyListRequest({
        limit: 1000,
        page: 1,
        name,
      });
      const fleetData = res.data?.data || [];
      const options = fleetData.map((item: any) => ({
        label: item.name,
        value: item.id,
      }));
      setFleetOptions(options);
    } catch (error) {
      console.error('获取车队列表失败:', error);
    }
  };

  return { fleetOptions, fetchFleetList };
};
